<template>
  <router-view ></router-view>
</template>

<style>
@import './assets/css/main.scss';
@font-face {
    font-family: "Inria Sans";
    src: local("Inria Sans"),
    url(./assets/fonts/Inria_Sans/InriaSans-Regular.ttf) format("truetype");
}
@font-face {
    font-family: "Inria Light";
    src: local("Inria Light"),
    url(./assets/fonts/Inria_Sans/InriaSans-Light.ttf) format("truetype");
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
